import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button"; // Assuming you have shadcn button
import { FileQuestion } from "lucide-react";

export const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="h-screen w-full flex flex-col items-center justify-center bg-[#F8F9FF] text-center p-4">
      
      {/* Icon Container */}
      <div className="bg-purple-100 p-6 rounded-full mb-6 animate-bounce">
        <FileQuestion className="h-16 w-16 text-[#3C3295]" />
      </div>

      {/* Text Content */}
      <h1 className="text-4xl font-bold text-gray-900 mb-2">404</h1>
      <h2 className="text-xl font-semibold text-gray-800 mb-4">Page not found</h2>
      <p className="text-gray-500 max-w-md mb-8">
        Sorry, the page you are looking for doesn't exist or has been moved.
      </p>

      {/* Back Button */}
      <Button
        onClick={() => navigate("/", { replace: true })}
        className="cursor-pointer w-full sm:w-auto flex items-center justify-center bg-linear-to-r from-pink-500 to-purple-600 hover:from-pink-600 hover:to-purple-700 text-white gap-2 px-8 transition-colors"
      >
        Back
      </Button>
    </div>
  );
};